function isImaSanteAccount(currentUser) {
    return currentUser.account_name === 'ima_sante';
}
function isCalizyAccount(currentUser) {
    return currentUser.account_name === 'calizy';
}
function isMgasAccount(currentUser) {
    return currentUser.account_name === 'mgas';
}
function isImhAccount(currentUser) {
    return currentUser.account_name === 'imh';
}
function isMatmutAccount(currentUser) {
    return currentUser.account_name === 'matmut';
}
function isMmeAccount(currentUser) {
    return currentUser.account_name === 'mme';
}
function isApizeeAccount(currentUser) {
    return currentUser.account_name === 'apizee';
}
function isApgisAccount(currentUser) {
    return currentUser.account_name === 'apgis';
}
function isMgefiAccount(currentUser) {
    return currentUser.account_name === 'mgefi';
}
function isHesAccount(currentUser) {
    return currentUser.account_name === 'hes';
}
function isRadianceAccount(currentUser) {
    return currentUser.account_name === 'radiance';
}
function isAlmAccount(currentUser) {
    return currentUser.account_name === 'alm';
}
function isPlanifAccount(currentUser) {
    return currentUser.account_name === 'planifique';
}
function isMondialAccount(currentUser) {
    return currentUser.account_name === 'mondial_relay';
}
function isDafassurAccount(currentUser) {
    return currentUser.account_name === 'dafassur';
}
function isMnhDirDevAccount(currentUser) {
    return currentUser.account_name === 'mnhdirdev';
}
function isVyvEsAccount(currentUser) {
    return currentUser.account_name === 'vyv_es';
}
export { isImaSanteAccount, isCalizyAccount, isMgasAccount, isImhAccount, isMatmutAccount, isMmeAccount, isApizeeAccount, isApgisAccount, isMgefiAccount, isHesAccount, isPlanifAccount, isAlmAccount, isMondialAccount, isDafassurAccount, isRadianceAccount, isMnhDirDevAccount, isVyvEsAccount, };
